<ui-modal
  class="reports-modal"
  [isOpened]="showScheduleReport"
  modalTitle="Schedule Reports"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="reports">
    <div class="reports__table-info-group-container">
      <div class="reports__table-info-container">
        <form [formGroup]="reportsForm">
          <div #divToScroll class="table-container">
            <table class="table-container__reports" ui-table>
              <thead>
                <tr>
                  <th class="report-type">Report Type</th>
                  <th class="identifier">Identifier</th>
                  <th class="sender">Sender</th>
                  <th class="recipients">Recipients</th>
                  <th class="parameters">Parameters</th>
                  <th class="run-frequency">Run Frequency</th>
                  <th class="run-time">Run Time</th>
                  <th class="run-time-zone">Run Time Zone</th>
                  <th class="market-data">Market Data</th>
                  <th class="active">Active</th>
                  <th class="run-now">Run Now</th>
                  <th class="load-report">Load Report</th>
                </tr>
              </thead>
              <tbody>
                <ng-container formArrayName="reportsArray">
                  <tr
                    tabindex="0"
                    *ngFor="let item of reportsFormArray; let i = index"
                    (click)="selectedReportIndex = i"
                    [ngClass]="{ 'selected-row': selectedReportIndex === i }"
                  >
                    <ng-container [formGroupName]="i">
                      <td>
                        <ng-select
                          [items]="reportTypeOptions"
                          [searchable]="false"
                          class="report-type"
                          formControlName="reportType"
                          (change)="reportTypeChange(item)"
                          appendTo="body"
                          [clearable]="false"
                        >
                        </ng-select>
                      </td>

                      <td>
                        <input
                          type="text"
                          class="input-cell identifier"
                          formControlName="identifier"
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          class="input-cell sender"
                          formControlName="sender"
                        />
                      </td>

                      <td>
                        <ng-select
                          class="recipients"
                          [items]="teamMembersEmails"
                          [multiple]="true"
                          [searchable]="true"
                          [closeOnSelect]="false"
                          [clearSearchOnAdd]="true"
                          formControlName="recipients"
                          placeholder="no recipients selected"
                          appendTo="body"
                        >
                          <ng-template
                            ng-multi-label-tmp
                            let-items="items"
                            let-clear="clear"
                          >
                            <div class="ng-value" *ngIf="items.length > 0">
                              <span class="ng-value-label"
                                >{{ items.length }}
                                {{
                                  items.length > 1
                                    ? 'recipients selected'
                                    : 'recipient selected'
                                }}</span
                              >
                            </div>
                          </ng-template>
                        </ng-select>
                      </td>

                      <td class="no-side-padding">
                        <button
                          class="input-cell__parameters-button"
                          formGroupName="parameters"
                          (click)="openParametersModal(item)"
                        >
                          Parameters
                        </button>
                      </td>

                      <td>
                        <ng-select
                          [items]="dropdownOptions.runFrequencies"
                          [searchable]="false"
                          [clearable]="false"
                          class="frequency"
                          formControlName="frequency"
                          appendTo="body"
                        >
                        </ng-select>
                      </td>

                      <td>
                        <ng-select
                          [items]="dropdownOptions.times"
                          [searchable]="false"
                          class="run-time"
                          formControlName="time"
                          appendTo="body"
                          [clearable]="false"
                        >
                        </ng-select>
                      </td>

                      <td>
                        <ng-select
                          [items]="dropdownOptions.timezones"
                          [searchable]="false"
                          class="run-time-zone"
                          formControlName="timezone"
                          appendTo="body"
                          [clearable]="false"
                        >
                        </ng-select>
                      </td>

                      <td>
                        <ng-select
                          [items]="dropdownOptions.marketDataTime"
                          [searchable]="false"
                          class="market-data"
                          formControlName="marketDataTime"
                          appendTo="body"
                          [clearable]="false"
                        >
                        </ng-select>
                      </td>

                      <td>
                        <input type="checkbox" formControlName="active" />
                      </td>

                      <td>
                        <input
                          type="checkbox"
                          formControlName="runNow"
                          (click)="runNow($any($event.target).checked)"
                        />
                      </td>

                      <td class="no-side-padding">
                        <button
                          class="input-cell__parameters-button"
                          formGroupName="parameters"
                          (click)="loadReport(item)"
                        >
                          Load
                        </button>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </form>

        <app-schedule-reports-parameters
          *ngIf="showParameterModal"
          [parametersFormGroup]="parametersFormGroupForModal"
          [parameters]="parametersToViewInModal"
          [showModal]="showParameterModal"
          [allCurrencyPairs]="allCurrencyPairs"
          (modalOpenStatusChanged)="parametersModalStatusChanged($event)"
          [outputFields]="parameterOutputOptionsForModal"
          [modalTitle]="'Parameters For Report'"
        ></app-schedule-reports-parameters>
        <div class="bottom-table-add">
          <div *ngIf="!loadingReports; else reportsLoading">
            <span class="add-text-container"
              ><label class="Page-1">+</label>
              <label class="add-text" (click)="addNewReport()"
                >Add Report</label
              ></span
            >
          </div>
          <ng-template #reportsLoading>
            <span class="add-text-container">
              <label class="add-text add-text--loading">Loading</label></span
            >
          </ng-template>
        </div>
      </div>

      <div class="reports__table-info-group-container__footer">
        <button
          class="
            ui-button ui-button__header ui-button--danger ui-button--delete
          "
          [disabled]="selectedReportIndex === null"
          (click)="deleteReport()"
        >
          Delete
        </button>

        <div class="run-selected-container">
          <label class="run-selected-container__header">Run Now</label>
          <form
            [formGroup]="reportsForm"
            (ngSubmit)="runReportsNow()"
            class="run-selected-container__form"
          >
            <div class="run-selected-container__settings">
              <div
                class="run-selected-container__settings__market-data_container"
              >
                <span
                  class="
                    run-selected-container__settings__market-data_container__market-data-text
                  "
                  >Market Data:</span
                >
                <div
                  class="
                    run-selected-container__settings__market-data_container__live-button__container
                  "
                >
                  <button
                    class="
                      ui-button ui-button__header
                      primary
                      run-selected-container__settings__market-data_container__live-button
                    "
                    [ngClass]="{ primary: marketDataLive }"
                    (click)="marketDateChange(true)"
                    type="button"
                  >
                    Live
                  </button>

                  <span class="market-data-time-label">Time:</span>
                </div>

                <div
                  class="
                    run-selected-container__settings__market-data_container__date-container
                    hide-clr-error
                  "
                >
                  <clr-date-container (mousedown)="marketDateChange(false)">
                    <input
                      class="market-data__date"
                      type="date"
                      clrDate
                      formControlName="marketData"
                      placeholder="DD MMM YYYY"
                    />
                  </clr-date-container>

                  <app-selector
                    (mousedown)="marketDateChange(false)"
                    [readonly]="marketDataLive"
                    [passedItems]="['New York 3pm', 'London 4pm']"
                    formControlName="marketDataTime"
                  >
                  </app-selector>
                </div>
              </div>

              <div
                class="
                  run-selected-container__settings__include-trades-on-screen
                "
              >
                <div class="clr-toggle-wrapper">
                  <input
                    type="checkbox"
                    id="toggle1"
                    name="toggle-basic"
                    value="option1"
                    class="clr-toggle"
                    formControlName="includeTrades"
                  />
                  <label for="toggle1">Include Trades on Screen</label>
                </div>
              </div>
            </div>

            <button
              class="ui-button ui-button__header primary run-selected"
              [ngClass]="{
                'run-selected--sent': runReportNowStatus === 'sent'
              }"
              [disabled]="
                !numberOfRunNowSelected ||
                (!marketDataLive && !marketDataValidity) ||
                runReportNowStatus
              "
              type="submit"
            >
              <label
                class="run-selected__text"
                [ngClass]="{
                  'run-selected__text--margin': runReportNowStatus === 'sent'
                }"
              >
                {{ runReportNowStatus === 'sent' ? 'Sent' : 'Run Selected' }}
              </label>
              <ng-container *ngIf="runReportNowStatus === 'sent'">
                <cds-icon shape="check" size="10"></cds-icon>
              </ng-container>
            </button>
          </form>
        </div>
      </div>
    </div>

    <div class="reports__footer">
      <button
        class="ui-button primary"
        [disabled]="!allowedToSave"
        (click)="saveChanges()"
      >
        <ng-container [ngSwitch]="savingReportsStatus">
          <span *ngSwitchCase="''"> Save </span>
          <span
            *ngSwitchCase="'LOADING'"
            class="spinner spinner-sm spinner-inverse"
          >
          </span>
          <span *ngSwitchCase="'DONE'"> Saved </span>
          <span *ngSwitchCase="'ERROR'"> Error </span>
        </ng-container>
      </button>
    </div>
  </div>
  <app-load-scheduled-report
    *ngIf="identifierToLoad"
    [showModal]="!!identifierToLoad"
    [identifier]="identifierToLoad"
    (modalOpenStatusChanged)="loadReportModalStatusChanged()"
  ></app-load-scheduled-report>
</ui-modal>
